<template>
    <div class="titled-box-container-rank1">
        <h2 class="titled-box-header">
            <br>
            <span><i>No.1</i></span>
            給湯器駆けつけ隊
        </h2>
        <div class="titled-box-content">
            <RatingBarRank1 />
            <div class="vendor-img">
                <img src="../../assets/rank-table/vendor-1.png" alt="">
            </div>
            <InfoGridRank1 />
            <RecommendPointRank1 />
            <!-- <ConstructionResultRank1 /> -->
            <ReviewsContentRank1 />
            <ButtonRank1 />
        </div>
    </div>
    <CvCard />
    <div class="titled-box-container-rank2">
        <h2 class="titled-box-header">
            <br>
            <span><i>No.2</i></span>
            キンライサー
        </h2>
        <div class="titled-box-content">
            <RatingBarRank2 />
            <div class="vendor-img">
                <img src="../../assets/rank-table/vendor-2.png" alt="">
            </div>
            <InfoGridRank2 />
            <RecommendPointRank2 />
            <!-- <ConstructionResultRank2 /> -->
            <ReviewsContentRank2 />
            <ButtonRank2 />
        </div>
    </div>
    <div class="titled-box-container-rank3">
        <h2 class="titled-box-header">
            <br>
            <span><i>No.3</i></span>
            街角給湯相談所
        </h2>
        <div class="titled-box-content">
            <RatingBarRank3 />
            <div class="vendor-img">
                <img src="../../assets/rank-table/vendor-3.png" alt="">
            </div>
            <InfoGridRank3 />
            <RecommendPointRank3 />
            <!-- <ConstructionResultRank3 /> -->
            <ReviewsContentRank3 />
            <ButtonRank3 />
        </div>
    </div>
</template>

<script setup>
import InfoGridRank1 from './InfoGridRank1.vue';
import InfoGridRank2 from './InfoGridRank2.vue';
import InfoGridRank3 from './InfoGridRank3.vue';
import RatingBarRank1 from './RatingBarRank1.vue';
import RatingBarRank2 from './RatingBarRank2.vue';
import RatingBarRank3 from './RatingBarRank3.vue';
import RecommendPointRank1 from './RecommendPointRank1.vue';
import RecommendPointRank2 from './RecommendPointRank2.vue';
import RecommendPointRank3 from './RecommendPointRank3.vue';
import ReviewsContentRank1 from './ReviewsContentRank1.vue';
import ReviewsContentRank2 from './ReviewsContentRank2.vue';
import ReviewsContentRank3 from './ReviewsContentRank3.vue';
// import ConstructionResultRank1 from './ConstructionResultRank1.vue';
// import ConstructionResultRank2 from './ConstructionResultRank2.vue';
// import ConstructionResultRank3 from './ConstructionResultRank3.vue';
import ButtonRank1 from './ButtonRank1.vue';
import ButtonRank2 from './ButtonRank2.vue';
import ButtonRank3 from './ButtonRank3.vue';
import CvCard from '../cv/CvCard.vue'
</script>

<style scoped>
.titled-box-container-rank1,
.titled-box-container-rank2,
.titled-box-container-rank3 {
    margin-top: 0;
    overflow: hidden;
}

.titled-box-container-rank1 .titled-box-header,
.titled-box-container-rank2 .titled-box-header,
.titled-box-container-rank3 .titled-box-header {
    background-color: #3f51b5;
    padding: 15px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: 900;
    font-size: 35px;
    margin-right: 10px;
    margin-left: 10px;
    border-radius: 10px 10px 0 0;
}

.titled-box-container-rank1 .titled-box-content,
.titled-box-container-rank2 .titled-box-content,
.titled-box-container-rank3 .titled-box-content {
    background-color: white;
    margin: 10px;
    margin-top: 0;
    border: 1px solid gray;
    border-radius: 0 0 10px 10px;
}

.vendor-img img {
    width: 95%;
}

.titled-box-header {
    position: relative;
    padding: 1rem 2rem 1rem 4em;
    margin-bottom: 0;
}

.titled-box-header span {
    position: absolute;
    top: -10px;
    left: 20px;
    display: inline-block;
    width: 70px;
    height: 50px;
    text-align: center;
}

.titled-box-header span i {
    position: relative;
    top: 35%;
    z-index: 1;
    width: 100%;
    font-size: 25px;
    font-style: normal;
    font-weight: 900;
    color: #fff;
    text-shadow:
        -1px -1px 0 #000,
        1px -1px 0 #000,
        -1px 1px 0 #000,
        1px 1px 0 #000;
}

.titled-box-container-rank1 .titled-box-header span {
    background: #ffc107;
}

.titled-box-container-rank1 .titled-box-header span:before {
    content: '';
    position: absolute;
    right: -10px;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #ffc107;
}

.titled-box-container-rank1 .titled-box-header span:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    display: block;
    height: 50%;
    border: 1em solid #ffc107;
    border-bottom-width: 15px;
    border-bottom-color: transparent;
}

.titled-box-container-rank2 .titled-box-header span {
    background: #aba4a4;
}

.titled-box-container-rank2 .titled-box-header span:before {
    content: '';
    position: absolute;
    right: -10px;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #aba4a4;
}

.titled-box-container-rank2 .titled-box-header span:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    display: block;
    height: 50%;
    border: 1em solid #aba4a4;
    border-bottom-width: 15px;
    border-bottom-color: transparent;
}

.titled-box-container-rank3 .titled-box-header span {
    background: #a0522d;
}

.titled-box-container-rank3 .titled-box-header span:before {
    content: '';
    position: absolute;
    right: -10px;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #a0522d;
}

.titled-box-container-rank3 .titled-box-header span:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    display: block;
    height: 50%;
    border: 1em solid #a0522d;
    border-bottom-width: 15px;
    border-bottom-color: transparent;
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {

    .titled-box-container-rank1 .titled-box-header,
    .titled-box-container-rank2 .titled-box-header,
    .titled-box-container-rank3 .titled-box-header {
        font-size: 25px;
    }

    .titled-box-header span {
        width: 60px;
    }

    .titled-box-header span i {
        font-size: 1.3rem;
    }

    .titled-box-container-rank1 .titled-box-header span:after {
        content: '';
        position: absolute;
        top: 30%;
        left: 0;
        display: block;
        height: 50%;
        border: 1.2em solid #ffc107;
        border-bottom-width: 15px;
        border-bottom-color: transparent;
    }

    .titled-box-container-rank2 .titled-box-header span:after {
        content: '';
        position: absolute;
        top: 30%;
        left: 0;
        display: block;
        height: 50%;
        border: 1.2em solid #aba4a4;
        border-bottom-width: 15px;
        border-bottom-color: transparent;
    }

    .titled-box-container-rank3 .titled-box-header span:after {
        content: '';
        position: absolute;
        top: 30%;
        left: 0;
        display: block;
        height: 50%;
        border: 1.2em solid #a0522d;
        border-bottom-width: 15px;
        border-bottom-color: transparent;
    }
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 480px) {

    .titled-box-container-rank1 .titled-box-content,
    .titled-box-container-rank2 .titled-box-content,
    .titled-box-container-rank3 .titled-box-content {
        margin-left: 5px;
        margin-right: 5px;
    }
    .titled-box-container-rank1 .titled-box-header,
    .titled-box-container-rank2 .titled-box-header,
    .titled-box-container-rank3 .titled-box-header {
        font-size: 20px;
        margin-left: 5px;
        margin-right: 5px;
    }

    .titled-box-header span {
        width: 50px;
    }

    .titled-box-header span i {
        font-size: 1.1rem;
    }

    .titled-box-container-rank1 .titled-box-header span:after {
        content: '';
        position: absolute;
        top: 30%;
        left: 0;
        display: block;
        height: 50%;
        border: 1.25em solid #ffc107;
        border-bottom-width: 15px;
        border-bottom-color: transparent;
    }

    .titled-box-container-rank2 .titled-box-header span:after {
        content: '';
        position: absolute;
        top: 30%;
        left: 0;
        display: block;
        height: 50%;
        border: 1.25em solid #aba4a4;
        border-bottom-width: 15px;
        border-bottom-color: transparent;
    }

    .titled-box-container-rank3 .titled-box-header span:after {
        content: '';
        position: absolute;
        top: 30%;
        left: 0;
        display: block;
        height: 50%;
        border: 1.25em solid #a0522d;
        border-bottom-width: 15px;
        border-bottom-color: transparent;
    }
}
</style>
